import {ApiError} from './apiError';

export class ServerError extends ApiError {
  constructor(message?: string) {
    super(message || '500 Server error');
  }
}
